import { render, staticRenderFns } from "./bestow.vue?vue&type=template&id=775408c3&"
import script from "./bestow.vue?vue&type=script&lang=js&"
export * from "./bestow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports